<template>
  <div id="tickets" :class="{ 'is-split-view': toggle }">
    <Loader :active="loading" :full="false"></Loader>
    <div class="columns">
      <div class="column">
        <div class="level is-mobile">
          <div class="level-left">
            <h1 class="title has-text-primary">Consultas</h1>
          </div>

          <div
            class="level-right"
            v-if="this.$hasPermission('consultas.crear')"
          >
            <b-button
              tag="router-link"
              :to="'/consultas/nuevo'"
              type="is-primary"
            >
              Crear Nueva
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="crm-filters-toggle"
      :aria-expanded="filtersOpen.toString()"
      aria-controls="ticket-filters"
      @click="filtersOpen = !filtersOpen"
    >
      <span><i class="fas fa-filter" aria-hidden="true"></i> Filtros</span>
      <i :class="filtersOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" aria-hidden="true"></i>
    </button>
    <form
      v-show="filtersOpen"
      id="ticket-filters"
      @submit.prevent="handleSearch"
      class="columns is-mobile mb-5 is-vcentered crm-filters-panel"
    >
      <!-- 🔍 TIPO -->
      <div class="column is-2-desktop is-12-mobile">
        <b-field label="Buscar por">
          <b-select v-model="selectDataType" expanded>
            <option disabled value="">Buscar por</option>
            <option v-for="(i, k) in dataType" :key="k" :value="i.type">
              {{ i.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <!-- 🔍 VALOR -->
      <div class="column is-3-desktop is-12-mobile">
        <b-field label="Valor">
          <input
            class="input"
            :type="selectDataType === 'nombre' ? 'text' : 'number'"
            v-model="searchText"
            placeholder="Nombre / DNI / CUIL"
          />
        </b-field>
      </div>

      <!-- 🏢 DEPARTAMENTO -->
      <div class="column is-2-desktop is-12-mobile">
        <b-field label="Departamento">
          <b-select v-model="filter.departament" expanded>
            <option value="">Todos</option>
            <option v-for="d in departaments.data" :key="d.id" :value="d.id">
              {{ d.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <!-- 📌 ESTADO -->
      <div class="column is-2-desktop is-12-mobile">
        <b-field label="Estado">
          <b-select v-model="filter.status" expanded>
            <option value="">Todos</option>
            <option v-for="s in statuses" :key="s.value" :value="s.value">
              {{ s.label }}
            </option>
          </b-select>
        </b-field>
      </div>

      <!-- 🏛️ DELEGACIÓN -->
      <div class="column is-2-desktop is-12-mobile" v-if="isDelegaciones">
        <b-field label="Delegación">
          <b-select v-model="filter.delegation" expanded>
            <option value="">Todas</option>
            <option v-for="d in delegations.data" :key="d.id" :value="d.id">
              {{ d.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <!-- 🔘 BOTÓN -->
      <div class="column is-narrow has-text-centered ticket-search-button">
        <b-field>
          <b-button type="is-primary" native-type="submit"> Buscar </b-button>
        </b-field>
      </div>
    </form>

    <div class="tickets-scroll" ref="scroll">
      <div
        class="columns ticket-list-grid"
      >
        <div
          class="column ticket-list-card"
          v-for="ticket in tickets.data"
          :key="ticket.id"
        >
          <Card
            :id="ticket.id"
            :link="`/consultas/id/${ticket.id}`"
            :title="ticket.contact"
            :description="ticket.departament"
            :status="ticket.status"
            :priority="ticket.priority"
            :origin="ticket.origin"
            :is_urgent="ticket.is_urgent"
            :color="ticket.color"
          />
        </div>
        <div v-if="hasMoreTickets" class="column is-12 has-text-centered">
          <b-button
            type="is-primary"
            size="is-medium"
            :loading="loading"
            @click="loadMore"
          >
            Cargar más
          </b-button>
        </div>
      </div>
    </div>

    <center v-if="empty">
      <b-icon pack="fas" icon="search" size="is-small" type="is-grey-light">
      </b-icon>
      No se encontraron resultados
    </center>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loader from "./Loader.vue";
import Search from "./Search.vue";
import Card from "./Ticket-card.vue";
const COLOR = {
  low: "success",
  medium: "warning",
  high: "danger",
};
const STATUS = {
  "not attended": "No atendido",
  open: "Abierto",
  closed: "Cerrado",
};
const ORIGIN = {
  whatsapp: {
    type: "is-success",
    pack: "fab",
    icon: "whatsapp",
    name: "Whatsapp",
  },
  messenger: {
    type: "is-info",
    pack: "fab",
    icon: "facebook-messenger",
    name: "Messenger",
  },
  instagram: {
    type: "is-light",
    pack: "fab",
    icon: "instagram",
    name: "Instagram",
  },
  web: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Web",
  },
  crm: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Crm",
  },
  email: {
    type: "is-light",
    pack: "far",
    icon: "envelope",
    name: "Email",
  },
  delegacion: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Delegación",
  },
  "call center": {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Call Center",
  },
  referido: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Referido",
  },
};
export default {
  name: "Tickets",
  components: {
    Loader,
    Search,
    Card,
  },
  data() {
    return {
      /* ===============================
       * FILTROS
       * =============================== */
      filter: {
        search: "",
        departament: "",
        delegation: "",
        user_id: "",
        status: "",
        activeTab: "Todos",
      },

      /* ===============================
       * LISTADO DE TICKETS
       * =============================== */
      tickets: {
        data: [],
        total: 0,
        order: "desc",
        page: 1,
        lastPage: "",
        perPage: 10,
      },

      /* ===============================
       * DATA PARA FILTROS
       * =============================== */
      departaments: {
        data: [], // [{ id, name }]
      },

      delegations: {
        data: [], // [{ id, name }]
      },

      users: {
        data: [], // [{ id, name, lastname }]
      },

      /* ===============================
       * BÚSQUEDA
       * =============================== */
      dataType: [
        { type: "id", name: "#" },
        { type: "nombre", name: "Nombre y apellido Afiliado" },
        { type: "dni", name: "DNI" },
        { type: "cuil", name: "CUIL" },
      ],

      statuses: [
        { value: "not attended", label: "No atendido" },
        { value: "open", label: "Abierto" },
        { value: "closed", label: "Cerrado" },
      ],

      selectDataType: "nombre",
      searchText: "",

      /* ===============================
       * ESTADOS DE UI
       * =============================== */
      empty: false,
      loading: false,
      filtersOpen: false,
      isMobileViewport: null,
    };
  },

  methods: {
    syncFiltersForViewport() {
      const isMobile = window.innerWidth <= 768;
      if (this.isMobileViewport !== isMobile) {
        this.isMobileViewport = isMobile;
        this.filtersOpen = !isMobile;
      }
    },
    async loadMore() {
      console.log("CLICK CARGAR MÁS");

      this.tickets.page += 1;
      await this.fetchTickets();
    },

    async fetchTickets() {
      console.log("FETCH PAGE:", this.tickets.page);

      if (this.$hasPermission("consultas.miusuario")) {
        this.filter.user_id = this.$store.getters["getSession"]["id"];
      }

      this.loading = true;

      const departament =
        this.filter.departament !== "" ? this.filter.departament : null;

      const delegation =
        this.filter.delegation !== "" ? this.filter.delegation : null;

      const status = this.filter.status !== "" ? this.filter.status : null;

      const query = await this.$repositories.tickets.index(
        this.tickets.page,
        this.searchText,
        this.selectDataType,
        this.filter.user_id,
        departament,
        delegation,
        status
      );

      const res = query.data.tickets;

      this.tickets.lastPage = res.last_page;

      res.data.forEach((item) => {
        this.tickets.data.push({
          id: item.id,
          contact: item.contact_name,
          departament: item.departament_name,
          origin: ORIGIN[item.origin],
          status: STATUS[item.status],
          priority: item.priority,
          is_urgent: item.is_urgent,
          color: item.status === "closed" ? "dark" : COLOR[item.priority],
        });
      });

      this.loading = false;
    },
    async fetchDelegations() {
      try {
        const res = await this.$repositories.delegations.list();
        this.delegations.data = res.data.delegations;
      } catch (error) {
        console.error("Error al cargar delegaciones", error);
      }
    },

    async fetchDepartaments() {
      try {
        const query = await this.$repositories.departaments.list_not_marketer();
        query.data.departaments.forEach((item) => {
          const items = {
            id: item.id,
            name: item.name,
            active: false,
          };
          this.departaments.data.push(items);
        });
      } catch (error) {
        console.log(error);
      }
    },

    getValue(value) {
      this.filter.search = value;
      this.tickets.data = [];
      this.fetchTickets();
    },
    handleSearch() {
      this.tickets.page = 1;
      this.tickets.data = [];
      this.fetchTickets();
    },
  },
  computed: {
    ...mapState(["toggle"]),
    isDelegaciones() {
      const depto = this.departaments.data.find(
        (d) => d.id === this.filter.departament
      );

      return depto?.name?.toLowerCase() === "delegaciones";
    },
    hasMoreTickets() {
      return Number(this.tickets.page) < Number(this.tickets.lastPage);
    },
  },
  watch: {
    isDelegaciones(val) {
      if (val) {
        this.fetchDelegations();
      } else {
        // si salís de Delegaciones, limpiamos
        this.filter.delegation = "";
        this.delegations.data = [];
      }
    },
  },

  created() {
    this.fetchDepartaments();
    this.fetchTickets();
    this.$EventBus.$on("updatedTicket", async () => {
      this.tickets.data = [];
      await this.fetchTickets();
    });
  },
  mounted() {
    this.syncFiltersForViewport();
    window.addEventListener("resize", this.syncFiltersForViewport);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncFiltersForViewport);
    this.$EventBus.$off("updatedTicket");
  },
};
</script>

<style lang="scss">
#tickets {
  position: relative;
  height: 100vh;
  padding: 1.5rem 1rem;
  overflow: hidden; // 🔒 mata el scroll externo

  center {
    text-transform: uppercase;
    font-weight: 500;
    color: $grey-light;
  }
}

.crm-filters-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 44px;
  margin-bottom: 0.75rem;
  padding: 0.65rem 0.9rem;
  color: #00758f;
  font: inherit;
  font-weight: 700;
  background: #fff;
  border: 1px solid #dcecef;
  border-radius: 10px;
}

.ticket-list-grid.columns {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  > .ticket-list-card.column {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    padding: 0;
  }

  > .column.is-12 {
    grid-column: 1 / -1;
  }
}

@media (min-width: 769px) {
  #tickets.is-split-view .ticket-list-grid.columns {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* 👉 ESTE es el único contenedor que scrollea */
.tickets-scroll {
  height: calc(100vh - 240px); // ajustá si el header cambia
  box-sizing: border-box;
  padding: 1rem;
  overflow-y: scroll;
  overflow-x: hidden;
}

@media (max-width: 768px) {
  #tickets {
    height: auto;
    min-height: 100%;
    padding: 1rem 0.75rem;
    overflow: visible;

    .level.is-mobile {
      align-items: flex-start;
      gap: 0.75rem;
    }

    .title {
      font-size: 1.55rem;
    }
  }

  #tickets .ticket-list-grid.columns {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    width: 100%;
    gap: 1rem;

    > .ticket-list-card.column {
      display: block;
      flex: none !important;
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
    }
  }

  .crm-filters-panel.columns.is-mobile {
    display: block;
    margin: 0 0 1rem;
    padding: 0.75rem;
    background: #fff;
    border: 1px solid #e6edef;
    border-radius: 10px;

    > .column {
      width: 100%;
      padding: 0.35rem 0;
    }

    .ticket-search-button .button {
      width: 100%;
    }
  }

  .tickets-scroll {
    height: auto;
    width: 100%;
    padding: 1rem 0.75rem;
    overflow: visible;
  }
}

/* nada de overflow en columns */
.columns {
  margin-left: 0;
  margin-right: 0;
}

.customSelect {
  .select,
  select {
    width: 100%;
    display: block;
  }
}
</style>
